'use client'

import React from 'react'
import {
    Col,
    Row,
    Card,
    CardBody,
    Container,
    Label,
    Input,
    InputGroup,
    Form,
    FormFeedback,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Button,
    Spinner,
    CardFooter
} from "reactstrap"
import PopupAttachment from "components/Input/attachment/PopupAttachment";
import MyEditor from "components/MyEditor";
import { HighlightContent } from './HighlightContent';

export const ESG4PlusCard1 = ({ validation, pageView }) => {
    return (
        <Card style={{ backgroundColor: "#d2ebffff" }}>
            <h5 className="card-header bg-transparent border-bottom text-uppercase">
                <i className='bx bx-cube-alt'></i> มุ่ง Net Zero Box
            </h5>
            <CardBody>
                <Row>
                    <Col className="col-12 mb-3">
                        <label
                            htmlFor="tab1Title"
                            className="col-md-12 col-form-label"
                        >
                            Title
                            <span className="t-require">*</span>
                        </label>
                        <div className="col-md-12">
                            <Input
                                id="tab1Title"
                                className="form-control"
                                type="text"
                                placeholder=""
                                name="tab1Title"

                                onChange={(e) => {
                                    validation.setFieldValue("tab1Title", e.target.value)
                                }}
                                onBlur={validation.handleBlur}
                                value={validation.values.tab1Title}
                                invalid={validation.touched.tab1Title && validation.errors.tab1Title ? true : false}
                                disabled={pageView === "view"}
                            />
                            {
                                validation.touched.tab1Title && validation.errors.tab1Title && (
                                    <FormFeedback type="invalid">
                                        {validation.errors.tab1Title}
                                    </FormFeedback>
                                )
                            }
                        </div>
                        <hr />
                    </Col>
                    <Col className="col-6 mb-3">
                        {/* {JSON.stringify(validation.values.tab1_icon1)} */}
                        <div className="col-md-12">
                            <PopupAttachment
                                typeDetail="single"
                                typeUpload="ImageMap"
                                upload="Image"
                                prefixName="tab1_icon1"
                                label="Icon1"
                                required={true}
                                description="description"
                                widthSize={48}
                                heightSize={48}
                                value={validation.values.tab1_icon1}
                                onChange={(value = {}, index) => {
                                    console.log("🚀 onChange ~ value:", value)
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('tab1_icon1', value)
                                }}
                                onRemove={(index) => {
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('tab1_icon1', {})
                                }}
                            />
                            {validation.touched.tab1_icon1 && validation.errors.tab1_icon1 && (
                                <div type="invalid" className="invalid-feedback d-block">
                                    {validation.errors.tab1_icon1}
                                </div>
                            )}
                        </div>
                        <hr />
                    </Col>
                    <Col className="col-6 mb-3">
                        <div className="col-md-12">
                            <PopupAttachment
                                typeDetail="single"
                                typeUpload="ImageMap"
                                upload="Image"
                                prefixName="tab1_icon2"
                                label="Icon2"
                                required={true}
                                description="description"
                                widthSize={80}
                                heightSize={80}
                                value={validation.values.tab1_icon2}
                                onChange={(value = {}, index) => {
                                    console.log("🚀 onChange ~ value:", value)
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('tab1_icon2', value)
                                }}
                                onRemove={(index) => {
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('tab1_icon2', {})
                                }}
                            />
                            {validation.touched.tab1_icon2 && validation.errors.tab1_icon2 && (
                                <div type="invalid" className="invalid-feedback d-block">
                                    {validation.errors.tab1_icon2}
                                </div>
                            )}
                        </div>
                        <hr />
                    </Col>
                    {/* <Col className="col-12 mb-3">
                                                                    <label
                                                                        htmlFor="slug"
                                                                        className="col-md-12 col-form-label"
                                                                    >
                                                                        Slug
                                                                        <span className="t-require">*</span>
                                                                    </label>
                                                                    <div className="col-md-12">
                                                                        <Input
                                                                            id="slug"
                                                                            className="form-control"
                                                                            type="text"
                                                                            placeholder=""
                                                                            name="slug"

                                                                            onChange={(e) => {
                                                                                validation.setFieldValue("slug", slugify(e.target.value))
                                                                            }}
                                                                            onBlur={validation.handleBlur}
                                                                            value={validation.values.slug}
                                                                            invalid={validation.touched.slug && validation.errors.slug ? true : false}
                                                                            disabled={pageView === "view"}
                                                                        />
                                                                        {
                                                                            validation.touched.slug && validation.errors.slug && (
                                                                                <FormFeedback type="invalid">
                                                                                    {validation.errors.slug}
                                                                                </FormFeedback>
                                                                            )
                                                                        }
                                                                    </div>
                                                                    <hr />
                                                                </Col> */}
                    <Col className="col-6 mb-3">
                        <label
                            htmlFor="tab1Detail"
                            className="col-md-12 col-form-label"
                        >
                            Detail 1
                            <span className="t-require">*</span>
                        </label>
                        <div className="col-md-12">
                            <MyEditor
                                id="tab1Detail"
                                placeholder=""
                                name="tab1Detail"
                                onChange={(e, editor) => {
                                    const data = editor.getData()
                                    validation.setFieldValue(
                                        "tab1Detail",
                                        data
                                    )
                                    console.log({ e, editor, data })
                                }}
                                onBlur={validation.handleBlur}
                                value={validation.values.tab1Detail}
                                invalid={
                                    validation.touched.tab1Detail &&
                                        validation.errors.tab1Detail
                                        ? true
                                        : false
                                }
                                disabled={pageView === "view"}
                            />
                            {validation.touched.tab1Detail &&
                                validation.errors.tab1Detail && (
                                    <FormFeedback type="invalid">
                                        {validation.errors.tab1Detail}
                                    </FormFeedback>
                                )}
                        </div>
                        <hr />
                    </Col>
                    <Col className="col-6 mb-3">
                        <label
                            htmlFor="tab1Detail2"
                            className="col-md-12 col-form-label"
                        >
                            Detail2
                            <span className="t-require">*</span>
                        </label>
                        <div className="col-md-12">
                            <MyEditor
                                id="tab1Detail2"
                                placeholder=""
                                name="tab1Detail2"
                                onChange={(e, editor) => {
                                    const data = editor.getData()
                                    validation.setFieldValue(
                                        "tab1Detail2",
                                        data
                                    )
                                    console.log({ e, editor, data })
                                }}
                                onBlur={validation.handleBlur}
                                value={validation.values.tab1Detail2}
                                invalid={
                                    validation.touched.tab1Detail2 &&
                                        validation.errors.tab1Detail2
                                        ? true
                                        : false
                                }
                                disabled={pageView === "view"}
                            />
                            {validation.touched.tab1Detail2 &&
                                validation.errors.tab1Detail2 && (
                                    <FormFeedback type="invalid">
                                        {validation.errors.tab1Detail2}
                                    </FormFeedback>
                                )}
                        </div>
                        <hr />
                    </Col>
                    <Col className="col-6 mb-3">
                        <label
                            htmlFor="tab1Detail3"
                            className="col-md-12 col-form-label"
                        >
                            Detail 3
                            <span className="t-require">*</span>
                        </label>
                        <div className="col-md-12">
                            <MyEditor
                                id="tab1Detail3"
                                placeholder=""
                                name="tab1Detail3"
                                onChange={(e, editor) => {
                                    const data = editor.getData()
                                    validation.setFieldValue(
                                        "tab1Detail3",
                                        data
                                    )
                                    console.log({ e, editor, data })
                                }}
                                onBlur={validation.handleBlur}
                                value={validation.values.tab1Detail3}
                                invalid={
                                    validation.touched.tab1Detail3 &&
                                        validation.errors.tab1Detail3
                                        ? true
                                        : false
                                }
                                disabled={pageView === "view"}
                            />
                            {validation.touched.tab1Detail3 &&
                                validation.errors.tab1Detail3 && (
                                    <FormFeedback type="invalid">
                                        {validation.errors.tab1Detail3}
                                    </FormFeedback>
                                )}
                        </div>
                        <hr />
                    </Col>
                    <Col className="col-6 mb-3">
                        <label
                            htmlFor="tab1Detail4"
                            className="col-md-12 col-form-label"
                        >
                            Detail 4
                            <span className="t-require">*</span>
                        </label>
                        <div className="col-md-12">
                            <MyEditor
                                id="tab1Detail4"
                                placeholder=""
                                name="tab1Detail4"
                                onChange={(e, editor) => {
                                    const data = editor.getData()
                                    validation.setFieldValue(
                                        "tab1Detail4",
                                        data
                                    )
                                    console.log({ e, editor, data })
                                }}
                                onBlur={validation.handleBlur}
                                value={validation.values.tab1Detail4}
                                invalid={
                                    validation.touched.tab1Detail4 &&
                                        validation.errors.tab1Detail4
                                        ? true
                                        : false
                                }
                                disabled={pageView === "view"}
                            />
                            {validation.touched.tab1Detail4 &&
                                validation.errors.tab1Detail4 && (
                                    <FormFeedback type="invalid">
                                        {validation.errors.tab1Detail4}
                                    </FormFeedback>
                                )}
                        </div>
                        <hr />
                    </Col>
                    <Col className="col-12 mb-3">
                        <div className="col-md-12">
                            <PopupAttachment
                                typeDetail="single"
                                typeUpload="ImageMap"
                                upload="Image"
                                prefixName="tab1_content_image"
                                label="Content Image"
                                required={true}
                                description="description"
                                widthSize={800}
                                heightSize={450}
                                value={validation.values.tab1_content_image}
                                onChange={(value = {}, index) => {
                                    console.log("🚀 onChange ~ value:", value)
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('tab1_content_image', value)
                                }}
                                onRemove={(index) => {
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('tab1_content_image', {})
                                }}
                            />
                            {validation.touched.tab1_content_image && validation.errors.tab1_content_image && (
                                <div type="invalid" className="invalid-feedback d-block">
                                    {validation.errors.tab1_content_image}
                                </div>
                            )}
                        </div>
                        <hr />
                    </Col>
                    <Col className="col-12 mb-3">
                        <div className="col-md-12">
                            <PopupAttachment
                                typeDetail="single"
                                typeUpload="ImageMap"
                                upload="Image"
                                prefixName="tab1_bg"
                                label="Background"
                                required={true}
                                description="description"
                                widthSize={2160}
                                heightSize={618}
                                value={validation.values.tab1_bg}
                                onChange={(value = {}, index) => {
                                    console.log("🚀 onChange ~ value:", value)
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('tab1_bg', value)
                                }}
                                onRemove={(index) => {
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('tab1_bg', {})
                                }}
                            />
                            {validation.touched.tab1_bg && validation.errors.tab1_bg && (
                                <div type="invalid" className="invalid-feedback d-block">
                                    {validation.errors.tab1_bg}
                                </div>
                            )}
                        </div>
                        <hr />
                    </Col>
                    <Col className="col-12 mb-3">
                        <label
                            htmlFor="tab1TitleSection1"
                            className="col-md-12 col-form-label"
                        >
                            Head Card Detail
                            <span className="t-require">*</span>
                        </label>
                        <div className="col-md-12">
                            <MyEditor
                                id="tab1TitleSection1"
                                placeholder=""
                                name="tab1TitleSection1"
                                onChange={(e, editor) => {
                                    const data = editor.getData()
                                    validation.setFieldValue(
                                        "tab1TitleSection1",
                                        data
                                    )
                                    console.log({ e, editor, data })
                                }}
                                onBlur={validation.handleBlur}
                                value={validation.values.tab1TitleSection1}
                                invalid={
                                    validation.touched.tab1TitleSection1 &&
                                        validation.errors.tab1TitleSection1
                                        ? true
                                        : false
                                }
                                disabled={pageView === "view"}
                            />
                            {validation.touched.tab1TitleSection1 &&
                                validation.errors.tab1TitleSection1 && (
                                    <FormFeedback type="invalid">
                                        {validation.errors.tab1TitleSection1}
                                    </FormFeedback>
                                )}
                        </div>
                        <hr />
                    </Col>
                    {/* <Col className="col-6 mb-3">
                        <label
                            htmlFor="tab1TitleSection1"
                            className="col-md-12 col-form-label"
                        >
                            Title Section1
                            <span className="t-require">*</span>
                        </label>
                        <div className="col-md-12">
                            <Input
                                id="tab1TitleSection1"
                                className="form-control"
                                type="text"
                                placeholder=""
                                name="tab1TitleSection1"

                                onChange={(e) => {
                                    validation.setFieldValue("tab1TitleSection1", e.target.value)
                                }}
                                onBlur={validation.handleBlur}
                                value={validation.values.tab1TitleSection1}
                                invalid={validation.touched.tab1TitleSection1 && validation.errors.tab1TitleSection1 ? true : false}
                                disabled={pageView === "view"}
                            />
                            {
                                validation.touched.tab1TitleSection1 && validation.errors.tab1TitleSection1 && (
                                    <FormFeedback type="invalid">
                                        {validation.errors.tab1TitleSection1}
                                    </FormFeedback>
                                )
                            }
                        </div>
                        <hr />
                    </Col>
                    <Col className="col-6 mb-3">
                        <label
                            htmlFor="tab1TitleSection2"
                            className="col-md-12 col-form-label"
                        >
                            Title Section2
                            <span className="t-require">*</span>
                        </label>
                        <div className="col-md-12">
                            <Input
                                id="tab1TitleSection2"
                                className="form-control"
                                type="text"
                                placeholder=""
                                name="tab1TitleSection2"

                                onChange={(e) => {
                                    validation.setFieldValue("tab1TitleSection2", e.target.value)
                                }}
                                onBlur={validation.handleBlur}
                                value={validation.values.tab1TitleSection2}
                                invalid={validation.touched.tab1TitleSection2 && validation.errors.tab1TitleSection2 ? true : false}
                                disabled={pageView === "view"}
                            />
                            {
                                validation.touched.tab1TitleSection2 && validation.errors.tab1TitleSection2 && (
                                    <FormFeedback type="invalid">
                                        {validation.errors.tab1TitleSection2}
                                    </FormFeedback>
                                )
                            }
                        </div>
                        <hr />
                    </Col> */}
                    {/* <Col className="col-6 mb-3">
                        <div className="col-md-12">
                            <PopupAttachment
                                typeDetail="single"
                                typeUpload="ImageMap"
                                upload="Image"
                                prefixName="tab1_section_image1"
                                label="Section Image1"
                                required={true}
                                description="description"
                                widthSize={440}
                                heightSize={228}
                                value={validation.values.tab1_section_image1}
                                onChange={(value = {}, index) => {
                                    console.log("🚀 onChange ~ value:", value)
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('tab1_section_image1', value)
                                }}
                                onRemove={(index) => {
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('tab1_section_image1', {})
                                }}
                            />
                            {validation.touched.tab1_section_image1 && validation.errors.tab1_section_image1 && (
                                <div type="invalid" className="invalid-feedback d-block">
                                    {validation.errors.tab1_section_image1}
                                </div>
                            )}
                        </div>
                        <hr />
                    </Col>
                    <Col className="col-6 mb-3">
                        <div className="col-md-12">
                            <PopupAttachment
                                typeDetail="single"
                                typeUpload="ImageMap"
                                upload="Image"
                                prefixName="tab1_section_image2"
                                label="Section Image2"
                                required={true}
                                description="description"
                                widthSize={440}
                                heightSize={228}
                                value={validation.values.tab1_section_image2}
                                onChange={(value = {}, index) => {
                                    console.log("🚀 onChange ~ value:", value)
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('tab1_section_image2', value)
                                }}
                                onRemove={(index) => {
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('tab1_section_image2', {})
                                }}
                            />
                            {validation.touched.tab1_section_image2 && validation.errors.tab1_section_image2 && (
                                <div type="invalid" className="invalid-feedback d-block">
                                    {validation.errors.tab1_section_image2}
                                </div>
                            )}
                        </div>
                        <hr />
                    </Col> */}
                    <Col className="col-4 mb-3">
                        <div className="col-md-12">
                            <PopupAttachment
                                typeDetail="single"
                                typeUpload="ImageMap"
                                upload="Image"
                                prefixName="tab1_card_image1"
                                label="Card Image1"
                                required={true}
                                description="description"
                                widthSize={768}
                                heightSize={960}
                                value={validation.values.tab1_card_image1}
                                onChange={(value = {}, index) => {
                                    console.log("🚀 onChange ~ value:", value)
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('tab1_card_image1', value)
                                }}
                                onRemove={(index) => {
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('tab1_card_image1', {})
                                }}
                            />
                            {validation.touched.tab1_card_image1 && validation.errors.tab1_card_image1 && (
                                <div type="invalid" className="invalid-feedback d-block">
                                    {validation.errors.tab1_card_image1}
                                </div>
                            )}
                        </div>
                        <hr />
                    </Col>
                    <Col className="col-4 mb-3">
                        <div className="col-md-12">
                            <PopupAttachment
                                typeDetail="single"
                                typeUpload="ImageMap"
                                upload="Image"
                                prefixName="tab1_card_image2"
                                label="Card Image2"
                                required={true}
                                description="description"
                                widthSize={768}
                                heightSize={960}
                                value={validation.values.tab1_card_image2}
                                onChange={(value = {}, index) => {
                                    console.log("🚀 onChange ~ value:", value)
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('tab1_card_image2', value)
                                }}
                                onRemove={(index) => {
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('tab1_card_image2', {})
                                }}
                            />
                            {validation.touched.tab1_card_image2 && validation.errors.tab1_card_image2 && (
                                <div type="invalid" className="invalid-feedback d-block">
                                    {validation.errors.tab1_card_image2}
                                </div>
                            )}
                        </div>
                        <hr />
                    </Col>
                    <Col className="col-4 mb-3">
                        <div className="col-md-12">
                            <PopupAttachment
                                typeDetail="single"
                                typeUpload="ImageMap"
                                upload="Image"
                                prefixName="tab1_card_image3"
                                label="Card Image2"
                                required={true}
                                description="description"
                                widthSize={768}
                                heightSize={960}
                                value={validation.values.tab1_card_image3}
                                onChange={(value = {}, index) => {
                                    console.log("🚀 onChange ~ value:", value)
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('tab1_card_image3', value)
                                }}
                                onRemove={(index) => {
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('tab1_card_image3', {})
                                }}
                            />
                            {validation.touched.tab1_card_image3 && validation.errors.tab1_card_image3 && (
                                <div type="invalid" className="invalid-feedback d-block">
                                    {validation.errors.tab1_card_image3}
                                </div>
                            )}
                        </div>
                        <hr />
                    </Col>

                    <Col className="col-4 mb-3">
                        <label
                            htmlFor="tab1Card1Detail"
                            className="col-md-12 col-form-label"
                        >
                            Card 1 Detail
                            <span className="t-require">*</span>
                        </label>
                        <div className="col-md-12">
                            <MyEditor
                                id="tab1Card1Detail"
                                placeholder=""
                                name="tab1Card1Detail"
                                onChange={(e, editor) => {
                                    const data = editor.getData()
                                    validation.setFieldValue(
                                        "tab1Card1Detail",
                                        data
                                    )
                                    console.log({ e, editor, data })
                                }}
                                onBlur={validation.handleBlur}
                                value={validation.values.tab1Card1Detail}
                                invalid={
                                    validation.touched.tab1Card1Detail &&
                                        validation.errors.tab1Card1Detail
                                        ? true
                                        : false
                                }
                                disabled={pageView === "view"}
                            />
                            {validation.touched.tab1Card1Detail &&
                                validation.errors.tab1Card1Detail && (
                                    <FormFeedback type="invalid">
                                        {validation.errors.tab1Card1Detail}
                                    </FormFeedback>
                                )}
                        </div>
                        <hr />
                    </Col>
                    <Col className="col-4 mb-3">
                        <label
                            htmlFor="tab1Card2Detail"
                            className="col-md-12 col-form-label"
                        >
                            Card 2 Detail
                            <span className="t-require">*</span>
                        </label>
                        <div className="col-md-12">
                            <MyEditor
                                id="tab1Card2Detail"
                                placeholder=""
                                name="tab1Card2Detail"
                                onChange={(e, editor) => {
                                    const data = editor.getData()
                                    validation.setFieldValue(
                                        "tab1Card2Detail",
                                        data
                                    )
                                    console.log({ e, editor, data })
                                }}
                                onBlur={validation.handleBlur}
                                value={validation.values.tab1Card2Detail}
                                invalid={
                                    validation.touched.tab1Card2Detail &&
                                        validation.errors.tab1Card2Detail
                                        ? true
                                        : false
                                }
                                disabled={pageView === "view"}
                            />
                            {validation.touched.tab1Card2Detail &&
                                validation.errors.tab1Card2Detail && (
                                    <FormFeedback type="invalid">
                                        {validation.errors.tab1Card2Detail}
                                    </FormFeedback>
                                )}
                        </div>
                        <hr />
                    </Col>
                    <Col className="col-4 mb-3">
                        <label
                            htmlFor="tab1Card3Detail"
                            className="col-md-12 col-form-label"
                        >
                            Card 3 Detail
                            <span className="t-require">*</span>
                        </label>
                        <div className="col-md-12">
                            <MyEditor
                                id="tab1Card3Detail"
                                placeholder=""
                                name="tab1Card3Detail"
                                onChange={(e, editor) => {
                                    const data = editor.getData()
                                    validation.setFieldValue(
                                        "tab1Card3Detail",
                                        data
                                    )
                                    console.log({ e, editor, data })
                                }}
                                onBlur={validation.handleBlur}
                                value={validation.values.tab1Card3Detail}
                                invalid={
                                    validation.touched.tab1Card3Detail &&
                                        validation.errors.tab1Card3Detail
                                        ? true
                                        : false
                                }
                                disabled={pageView === "view"}
                            />
                            {validation.touched.tab1Card3Detail &&
                                validation.errors.tab1Card3Detail && (
                                    <FormFeedback type="invalid">
                                        {validation.errors.tab1Card3Detail}
                                    </FormFeedback>
                                )}
                        </div>
                        <hr />
                    </Col>

                    <Col className="col-12 mb-3">
                        <label
                            htmlFor="tab1TitleSection2"
                            className="col-md-12 col-form-label"
                        >
                            Highlight Title
                            <span className="t-require">*</span>
                        </label>
                        <div className="col-md-12">
                            <Input
                                id="tab1TitleSection2"
                                className="form-control"
                                type="text"
                                placeholder=""
                                name="tab1TitleSection2"

                                onChange={(e) => {
                                    validation.setFieldValue("tab1TitleSection2", e.target.value)
                                }}
                                onBlur={validation.handleBlur}
                                value={validation.values.tab1TitleSection2}
                                invalid={validation.touched.tab1TitleSection2 && validation.errors.tab1TitleSection2 ? true : false}
                                disabled={pageView === "view"}
                            />
                            {
                                validation.touched.tab1TitleSection2 && validation.errors.tab1TitleSection2 && (
                                    <FormFeedback type="invalid">
                                        {validation.errors.tab1TitleSection2}
                                    </FormFeedback>
                                )
                            }
                        </div>
                        <hr />
                    </Col>
                    <Col className="col-12 mb-3">
                        <label
                            htmlFor="tab1LinkUrl"
                            className="col-md-12 col-form-label"
                        >
                            Highlight Link URL
                            {/* <span className="t-require">*</span> */}
                        </label>
                        <div className="col-md-12">
                            <Input
                                id="tab1LinkUrl"
                                className="form-control"
                                type="text"
                                placeholder=""
                                name="tab1LinkUrl"

                                onChange={(e) => {
                                    validation.setFieldValue("tab1LinkUrl", e.target.value)
                                }}
                                onBlur={validation.handleBlur}
                                value={validation.values.tab1LinkUrl}
                                invalid={validation.touched.tab1LinkUrl && validation.errors.tab1LinkUrl ? true : false}
                                disabled={pageView === "view"}
                            />
                            {
                                validation.touched.tab1LinkUrl && validation.errors.tab1LinkUrl && (
                                    <FormFeedback type="invalid">
                                        {validation.errors.tab1LinkUrl}
                                    </FormFeedback>
                                )
                            }
                        </div>
                        <hr />
                    </Col>

                    {/* <HighlightContent validation={validation} pageView={pageView} /> */}
                </Row>
            </CardBody>
        </Card>

    )
}